import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  label: string
  value: string | number
}

export const InfoAboutTripRow = ({ label, value }: Props) => {
  return (
    <div className={s.infoRow}>
      <p className={clsx('regular-12', s.infoLabel)}>{label}</p>
      <p className={clsx('regular-14', s.value)}>{value}</p>
    </div>
  )
}
